import {sleep} from './sleep';

export const minDelay = <T>(promise: Promise<T>, ms: number) =>
    Promise.all([promise, sleep(ms)]).then(([value]) => value);
